<template>
  <div v-if="isCustomerServiceDataAvailable" class="simple-footer">
    <div class="simple-footer__aside">
      <p class="simple-footer__title">{{ $t('customer_service.need_help') }}</p>
      <img class="simple-footer__logo" alt="On" src="~/images/logo/on-logo--black.svg" />
    </div>
    <div class="simple-footer__content">
      <ul>
        <li>
          <a
            :class="[
              'simple-footer__chat',
              isChatOnline ? 'simple-footer__chat--online' : 'simple-footer__chat--offline',
            ]"
            @click="openChat"
            >{{ $t('customer_service.live_chat') }}</a
          >
        </li>
        <li>
          <a class="simple-footer__phone" :href="`tel:${customerServiceData.phone}`">{{
            customerServiceData.phone
          }}</a>
        </li>
        <li>
          <a class="simple-footer__email" :href="`mailto:${customerServiceData.email}`">{{
            $t('customer_service.email_us')
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SimpleFooter',

  props: {
    customerServiceData: {
      type: Object,
      required: true,
      validator(obj) {
        return ['email', 'phone'].every(k => typeof obj[k] != 'undefined')
      },
    },
  },

  computed: {
    ...mapGetters({
      isChatOnline: 'page/isChatOnline',
    }),

    isCustomerServiceDataAvailable() {
      return this.customerServiceData.phone && this.customerServiceData.email
    },
  },

  methods: {
    openChat() {
      if (this.isChatOnline) LC_API.open_chat_window()
    },
  },
}
</script>

<style scoped lang="scss">
.simple-footer {
  display: flex;
  flex-flow: row;
  padding-top: 13px;
  border-top: 1px solid $color-grey-mid-1;

  &__aside {
    width: 116px;
  }

  &__content {
    margin-left: 16px;
  }

  &__title {
    font-weight: bold;
    line-height: 18px;
    font-size: 14px;
    letter-spacing: 0.3px;
  }

  &__logo {
    width: 18px;
    margin-top: 28px;
  }

  &__chat,
  &__phone,
  &__email {
    cursor: pointer;
    color: $color-grey-mid-3;
    line-height: 20px;
    font-size: 12px;
    letter-spacing: 0.2px;

    &:hover {
      color: $color-grey-dark-2;
    }
  }

  &__chat {
    &--online:before {
      content: '';
      display: inline-block;
      height: 8px;
      width: 8px;
      margin-right: 8px;
      margin-left: -16px;
      background-color: #26dfb3;
      border-radius: 100%;
    }
    &--offline {
      cursor: default;
      color: $color-grey-mid-2;

      &:hover {
        color: $color-grey-mid-2;
      }
    }
  }
}
</style>
